import { useStore, selectPendingPicks } from '@/infra/store';
import { useT } from '@/infra/i18n';
import { getCombatRunService } from '@/services/combat-run';
import { COLORS, SPACING, RADIUS, FONT } from '@/presentation/theme/tokens';
import { overlayStyle, cardStyle } from '@/presentation/modals/modal-shared';

const RARITY_COLOR: Record<string, string> = {
  common: '#aaaabb',
  rare: '#5aafff',
  epic: '#ff8b3a',
};

export function MutationPickModal() {
  const t = useT();
  const picks = useStore(selectPendingPicks);
  if (picks.length === 0) return null;
  return (
    <div role="dialog" data-testid="mutation-pick-modal" style={overlayStyle}>
      <div style={{ ...cardStyle, maxWidth: 480 }} onClick={(e) => e.stopPropagation()}>
        <h2 style={titleStyle}>✨ {t('mutation.pick.title')}</h2>
        <p style={bodyStyle}>{t('mutation.pick.body')}</p>
        <div style={pickRow}>
          {picks.map((p) => (
            <button
              key={p.id}
              data-testid={`mutation-pick-${p.id}`}
              onClick={() => getCombatRunService().applyPick(p.id)}
              style={{
                ...cardBtn,
                borderColor: RARITY_COLOR[p.rarity],
                boxShadow: `0 0 16px ${RARITY_COLOR[p.rarity]}55`,
              }}
            >
              <div style={{ ...rarityBadge, color: RARITY_COLOR[p.rarity] }}>
                {p.rarity.toUpperCase()}
              </div>
              <div style={nameStyle}>{t(`mutation.${p.id}.name`)}</div>
              <div style={descStyle}>{t(`mutation.${p.id}.desc`)}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

const titleStyle: React.CSSProperties = {
  margin: `0 0 ${SPACING.sm}px 0`,
  fontSize: FONT.sizeLg,
  color: COLORS.accent,
  textAlign: 'center',
};
const bodyStyle: React.CSSProperties = {
  color: COLORS.textDim,
  fontSize: FONT.sizeSm,
  textAlign: 'center',
  marginBottom: SPACING.lg,
};
const pickRow: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: SPACING.sm,
};
const cardBtn: React.CSSProperties = {
  background: COLORS.surfaceAlt,
  border: '2px solid',
  borderRadius: RADIUS.md,
  padding: SPACING.md,
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  gap: SPACING.xs,
  alignItems: 'flex-start',
  textAlign: 'left',
  color: COLORS.text,
};
const rarityBadge: React.CSSProperties = {
  fontSize: FONT.sizeXs,
  fontFamily: FONT.mono,
  letterSpacing: 1,
  fontWeight: 700,
};
const nameStyle: React.CSSProperties = {
  fontSize: FONT.sizeMd,
  fontWeight: 600,
};
const descStyle: React.CSSProperties = {
  fontSize: FONT.sizeXs,
  color: COLORS.textDim,
};
